import { Tag } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { MessageStatus } from "../types/messages.types.ts"

const COLORS: Record<MessageStatus, string> = {
  queued: "default",
  sending: "processing",
  sent: "blue",
  delivered: "green",
  bounced: "red",
  complained: "red",
  failed: "red",
  skipped: "orange"
}

export const MessageStatusTag = ({ status }: { status: MessageStatus }) => {
  const { t } = useTranslation()
  return (
    <Tag color={COLORS[status] ?? "default"}>
      {t(`communication.messages.status.${status}`, { defaultValue: status })}
    </Tag>
  )
}
